<div class="dialog-container">
  <div class="dialog-header">
    <h2 mat-dialog-title>Edit Bot</h2>
    <button mat-icon-button (click)="onClose()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form [formGroup]="editBotForm" (ngSubmit)="onSubmit()">
    <div mat-dialog-content class="dialog-content">
      <div class="create-bot-content">

        <mat-form-field class="full-width">
          <mat-label>Bot Name</mat-label>
          <input matInput formControlName="name" placeholder="Enter bot name" required>
          <mat-error *ngIf="editBotForm.get('name')?.hasError('required')">
            Bot name is required
          </mat-error>
        </mat-form-field>

        <div class="image-upload-section">
          <label class="image-upload-label">Bot Image</label>
          <input
            type="file"
            #fileInput
            accept="image/*"
            (change)="onImageSelected($event)"
            style="display: none"
          />
          <div
            class="upload-zone"
            [class.has-image]="imagePreview"
            (click)="fileInput.click()"
          >
            <ng-container *ngIf="!imagePreview">
              <mat-icon class="upload-icon">add_photo_alternate</mat-icon>
              <span class="upload-text">Click to upload image</span>
            </ng-container>
            <ng-container *ngIf="imagePreview">
              <img [src]="imagePreview" alt="Bot preview" class="image-preview" />
              <button
                type="button"
                mat-icon-button
                (click)="$event.stopPropagation(); removeImage()"
                class="remove-image-button"
                aria-label="Remove image"
              >
                <mat-icon>close</mat-icon>
              </button>
            </ng-container>
          </div>
        </div>

        <div class="cameras-section">
          <div class="cameras-header">
            <h3>Cameras</h3>
            <button type="button" mat-icon-button color="primary" (click)="addCamera()" aria-label="Add camera">
              <mat-icon>add</mat-icon>
            </button>
          </div>

          <div formArrayName="cameras" class="cameras-list">
            <p *ngIf="cameras.length === 0" class="cameras-empty">No cameras added. Click + to add one.</p>
            <div *ngFor="let camera of cameras.controls; let i = index" [formGroupName]="i" class="camera-item">
              <mat-form-field class="camera-name-field">
                <mat-label>Camera Name</mat-label>
                <input matInput formControlName="name" [placeholder]="'Camera ' + (i + 1)" required>
                <mat-error *ngIf="getCameraControl(i)?.get('name')?.hasError('required')">
                  Camera name is required
                </mat-error>
              </mat-form-field>
              <button type="button" mat-icon-button color="warn" (click)="removeCamera(i)" aria-label="Remove camera">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div mat-dialog-actions class="dialog-actions">
      <button type="button" mat-button (click)="onClose()">Cancel</button>
      <button type="submit" mat-raised-button color="primary">Save</button>
    </div>
  </form>
</div>
